import { render, staticRenderFns } from "./driver-information.component.vue?vue&type=template&id=4e2f3260"
import script from "./driver-information.component.ts?vue&type=script&lang=ts&external"
export * from "./driver-information.component.ts?vue&type=script&lang=ts&external"
import style0 from "./driver-information.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports